import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mergeDeepLeft, path, clone, find, propEq } from 'ramda';
import loadImage from 'blueimp-load-image';

import Breadcrumbs from '../../common/Breadcrumbs';
import DragAndDrop from '../../common/DragAndDrop';
import {
  fetchTaskById,
  getAttachmentsById,
  deleteAttachmentById,
  uploadAttachmentData,
} from '../../api/task';
import './style.css'
import config from '../../config';
import { addNotification as notify } from 'reapop';
import { bindFieldAndData } from '../Task/data';
import ConfirmAction from '../../common/ConfirmAction';
import {changeModalState} from "../../actions/modal";
import {deleteObject} from "../../actions/objectToDelete";

export class TaskAttachments extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fileToUpload: [],
    }
    this.renderAttachments = this.renderAttachments.bind(this);
    this.handleAttachmentUpload = this.handleAttachmentUpload.bind(this);
    this.removeAttachmentFromLocalState = this.removeAttachmentFromLocalState.bind(this);
    this.uploadAttachment = this.uploadAttachment.bind(this);
    this.getFileIcon = this.getFileIcon.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
  }

  componentWillMount() {
    const id = path(['match', 'params', 'id'], this.props);
    this.props.loadAttachments(id);
    this.props.getDataById(id);
  }

  handlerDelete(id) {
    let data = {id: id, test: 'asas'};
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: deleteAttachmentById,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'removeAttachment',
    });
  }

  getFileIcon(attachment) {
    if (attachment.mime_type) {
      if (attachment.mime_type.match(/image\/*/)) {
        return <img className="card-block-files-for-upload pull-left"
                    src={`${config.apiEndpoint}/uploads/attachments/${attachment.task_id}/${attachment.attachment}`}
                    onError={() => {
                      document.getElementById(attachment.attachment).innerHTML = '<i class="fa fa-file-o fa-4x card-block-thumb-mini"></i>';
                    }}
        />
      }
      if (attachment.mime_type.match(/application\/pdf/)) {
        return <img className="card-block-files-for-upload pull-left"
                    src="/assets/pdf-icon.png"/>
      }
      if (attachment.mime_type.match(/video\/*/)) {
        return <img className="card-block-files-for-upload pull-left"
                    src="/assets/video-icon.png"/>
      }
    }

    return <img className="card-block-files-for-upload pull-left"
                       src="/assets/unknown-file.png"/>
  }

  renderAttachments() {
    const attachments = path(['tasks', 'currentAttachments'], this.props);
    const taskId = path(['match', 'params', 'id'], this.props);
    const attachmentsList = [];
    if (attachments && attachments.length > 0) {
      for (let i = 0; i < attachments.length; i++) {
        attachmentsList.push(
          <div className="card rounded" style={{ padding: '10px', marginBottom: '6px' }} key={i}>
            {attachments[i].type ? <span style={{ color: 'green' }}>QC</span> : null}
            <span className="pull-left">
              <div id={attachments[i].attachment}
                className="card-block-wrap-inside card-block-file card-block-wrap-image-from-server">
                {this.getFileIcon(attachments[i])}
              </div>
              <div style={{
                display: 'inline-grid'
              }}><b
                style={{
                  position: 'relative',
                }}
              >
                  {attachments[i].name}
                </b>
                <span style={{
                  marginTop: '7px'
                }}>
                  <a target="_blank" download={attachments[i].name}
                    className='btn btn-rounded btn-icon ui-btn card-block-button-a'
                    href={`${config.apiEndpoint}/uploads/attachments/${taskId}/${attachments[i].attachment}`}>
                    <i className="material-icons">expand_more</i><span>Download</span>
                  </a>
                  <a target="_blank" className='btn btn-rounded btn-icon ui-btn card-block-button-a'
                    href={`${config.apiEndpoint}/uploads/attachments/${taskId}/${attachments[i].attachment}`}>
                    <i className="material-icons">fullscreen</i><span>View</span>
                  </a>
                  <button
                    type="button"
                    className="btn btn-rounded btn-icon ui-btn card-block-button-a"
                    onClick={() => { this.handlerDelete(attachments[i].id); }}
                  >
                    <i className="material-icons">remove_circle_outline</i>
                    <span className="color-default">Remove</span>
                  </button>
                </span>
              </div>
            </span>
            <ConfirmAction id={'removeAttachment'} content={'Are you sure you want to delete this attachment?'}/>
          </div>
        );
      }
    }

    return attachmentsList;
  }

  renderLocalAttachments(fileToUpload) {
    return fileToUpload.map((name, index) => {
      return <div className="card-block-wrap">
        <div className="card-block-close-wrap">
          <i className="material-icons card-block-cancel"
            onClick={() => this.removeAttachmentFromLocalState(index)}>cancel</i>
        </div>
        <div className="card-block-wrap-inside card-block-file">
          {(fileToUpload[index].imageSrc ?
            <img src={fileToUpload[index].imageSrc}
              className={'card-block-files-for-upload' + (fileToUpload[index].loaded && ' loaded')} />
            :
            <i className="fa fa-file-o fa-4x card-block-thumb"></i>
          )}
        </div>
        <div className="card-block-wrap-inside">
          <span>{fileToUpload[index].name}</span>
          <span> - {fileToUpload[index].size}</span>
        </div>
      </div>
    })
  }

  removeAttachmentFromLocalState(idOfFileInState) {
    const filesObjectToMerge = clone(this.state);
    delete filesObjectToMerge.fileToUpload[idOfFileInState];
    this.setState(mergeDeepLeft(filesObjectToMerge, this.state));
  }

  // Component method
  async handleAttachmentUpload(e) {
    const files = [...e.target.files];
    const pattern = /image-*|application\/pdf|application\/x-pdf|video\/mov|video\/mp4|video\/3gp|video\/ogg/;

    const filesObjectToMerge = clone(this.state);
    for (let file of files) {
      const reader = new FileReader();
      const positionForNewFile = filesObjectToMerge.fileToUpload.length;
      const fileSize = ('' + (file.size / 1048576)).slice(0, 4);
      if (fileSize > 500) {
        this.props.addErrorNotification(file.name + " is bigger than 500Mb.");
        continue;
      }
      filesObjectToMerge.fileToUpload[positionForNewFile] = {
        name: file.name,
        size: fileSize + 'Mb',
        fileObject: file,
      };
      if (file.type.match(pattern)) {
        if (file.type.match(/image-*/)) {
          const result = await loadImage(file, {orientation: true, meta: true, canvas: true});
          filesObjectToMerge.fileToUpload[positionForNewFile].imageSrc = result.image.toDataURL();
        } else if(file.type.match(/video\/*/)) {
          filesObjectToMerge.fileToUpload[positionForNewFile].imageSrc = "/assets/video-icon.png";
        } else {
          filesObjectToMerge.fileToUpload[positionForNewFile].imageSrc = "/assets/pdf-icon.png";
        }
        filesObjectToMerge.fileToUpload[positionForNewFile].loaded = true;
        this.setState(mergeDeepLeft(filesObjectToMerge, this.state));
      } else {
        this.props.addErrorNotification("Invalid file type");
      }
      this.setState(mergeDeepLeft(filesObjectToMerge, this.state));
    }
  }

  uploadAttachment(qc) {
    const id = path(['match', 'params', 'id'], this.props);
    for (let key in this.state.fileToUpload) {
      const formData = new FormData();
      const file = this.state.fileToUpload[key].fileObject;
      formData.append('file', file);
      this.props.uploadAttachment(id, formData, qc);
    }

    this.setState(mergeDeepLeft({ fileToUpload: [] }, this.state));
  }

  handleDrop = (files) => {
    const e = { target: { files: Array.from(files) } };
    this.handleAttachmentUpload(e);
  }

  render() {
    const id = path(['match', 'params', 'id'], this.props);
    const fileToUpload = this.state.fileToUpload;

    const fields = path(['tasks', 'current', 'fields'], this.props);
    const fields_detail = path(['tasks', 'current', 'fields_detail'], this.props);
    let taskLabel = 'Task';

    if (fields && fields_detail) {
      const data = bindFieldAndData(fields, fields_detail);
      const woField = find(propEq('label', 'Work Order'), data);
      if (woField && woField.content) {
        taskLabel = `Task ${woField.content}`;
      }
    }

    return (
      <div>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { url: '/pages/task/' + id, icon: 'library_books', name: taskLabel },
          { icon: 'attach_file', name: 'Add File' },
        ]} />
        <div>
          <div className="card rounded mb-3">
            <div className="card-header rounded-top">
              Attachment(s)
            </div>
            <div className="card-block">
              {this.renderAttachments()}
            </div>
          </div>
          <div className="card rounded mb-3">
            <div className="card-header rounded-top">
              Upload File
            </div>
            <div className="card-block" style={{paddingBottom: '0px'}}>
              <DragAndDrop handleDrop={this.handleDrop} style={{ paddingBottom: '25px' }}>
              </DragAndDrop>
              <div className="card-block-buttons">
                <label
                  ref="uploadBtn"
                  className="btn btn-rounded btn-icon ui-btn pull-right"
                  onClick={() => { this.uploadAttachment(true); }}
                  style={{
                    position: 'relative',
                  }}
                >
                  <i className="material-icons">send</i>
                  <span className="color-default">Upload as QC</span>
                </label>
                <label
                  ref="uploadBtn"
                  className="btn btn-rounded btn-icon ui-btn pull-right"
                  onClick={() => { this.uploadAttachment(); }}
                  style={{
                    position: 'relative',
                    marginRight: '10px',
                  }}
                >
                  <i className="material-icons">send</i>
                  <span className="color-default">Upload</span>
                </label>
                <label
                  className="btn btn-rounded btn-icon ui-btn pull-right"
                  style={{
                    position: 'relative',
                    marginRight: '10px',
                  }}>
                  <i className="material-icons">attachment</i>
                  <span className="color-default">Browse</span>
                  <input ref="input" type="file" onChange={this.handleAttachmentUpload}
                    className="d-none"
                    multiple="true" />
                </label>
              </div>
            </div>
            <div className="card-block-container-of-files" style={{paddingTop: fileToUpload.length > 0 ? '1.25rem' : ''}}>{this.renderLocalAttachments(fileToUpload)}</div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
}

const mapDispatchToProps = (dispatch) => {
  return {
    getDataById: (id) => {
      fetchTaskById(id)(dispatch);
    },
    loadAttachments: (id) => {
      getAttachmentsById(id)(dispatch);
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    },
    uploadAttachment: (id, formData, qc) => {
      uploadAttachmentData(id, formData, qc)(dispatch);
    },
    addErrorNotification: (message) => {
      dispatch(notify({
        title: 'Upload attachment',
        message: message,
        status: 'error',
        position: 'tr',
        dismissible: true,
        dismissAfter: 3000,
      }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskAttachments);



// WEBPACK FOOTER //
// ./src/containers/TaskAttachments/index.js